/**
 * PlayerNamePanel.js
 * - handler for the player
 * @since May 22, 2019
 * @author
 * - Aron Joshua Bagtas <aaron@qstrike.com>
 *
 * Requirements:
 * - jQuery
 * - Mustache
 *
 * Usage:
 *  Handle the setup of player name panel
 *  Handle the events for player name
 */


function PlayerNamePanel () {

}

PlayerNamePanel.availableTextShapes = [
    'none',
    'arc',
    'Vertical Arched'
]

PlayerNamePanel.type = "player_name";
PlayerNamePanel.configuration = {
    type: "player_name",
    perspective: "back",
    side: undefined
}

PlayerNamePanel.events = {
    isInit: true,
    reloadTextShape: true,

    init: function() {
        var that = this;
        if (that.isInit) {
            // Events HERE
            $(".modifier_main_container").on("click", "#player-name-panel .add-player-name .btn-selection-choice", that.onClickAddPlayerName);
            $('.modifier_main_container').on('click', '#player-name-panel .playerOptionContainer .colorItem[data-object-type="accent"]', that.onChangeAccentColor);
            $('.modifier_main_container').on('click', '#player-name-panel .m-accents .btn-selection-choice', that.onSelectFontAccent);
            $('.modifier_main_container').on('click', '#player-name-panel .playerOptionContainer a.change-font-style', that.onChangeFontStyle);
            $('.modifier_main_container').on('click', '#player-name-panel .remove-player-name', that.onRemovePlayerName);
            $(".modifier_main_container").on('click', '#player-name-panel .select-font-style', that.onCreateFontPopUp);
            $(".modifier_main_container").on('keypress, keyup', '#player-name-panel input.app-letters-input', that.onKeyPressApplicationText);
            $(".modifier_main_container").on('blur', '#player-name-panel input.app-letters-input', that.onBlurApplicationText);
            $(".modifier_main_container").on('click', '#player-name-panel .view-all-application', that.onViewAllDecoration);

            // Player Name Layout
            $(".modifier_main_container").on("click", "#player-name-panel .select-player-name-layout", that.onSelectTextLayout);
            $(".modifier_main_container").on("click", "#player-name-panel .change-player-name-layout", that.onChangeTextLayout);

            that.isInit = false;
        }

        var playerObj = _.find(ub.current_material.settings.applications, {type: "player_name"});
        var playerObjTextShape = TextShapeCore.utilities.findTextShape(PlayerNamePanel.type);

        if (typeof playerObj !== "undefined") {
            PlayerNamePanel.funcs.initializePlayerName(playerObj.code);
        } else if (playerObjTextShape) {
            // prevent textshape reload issue on saved design (SRE-968)
            //  Reload Text if saved design have text shape
            // if (typeof ub.config.savedDesignInfo === "object") {
            //     if (that.reloadTextShape) {
            //         TextShapeCore.textShape.reload(playerObjTextShape.code);
            //         that.reloadTextShape = false;
            //     }
            // }

            PlayerNamePanel.funcs.initializePlayerName(playerObjTextShape.code);
        } else {
            PlayerNamePanel.funcs.loadAddPlayer();
        }
    },

    onViewAllDecoration: function() {
        ApplicationList.events.init();
    },

    onClickAddPlayerName: function() {
        var configuration = PlayerNamePanel.configuration;
        var part = "Back Body";
        var _perspective = "back";

        ApplicationCore.funcs.createNewPlayerName(configuration.perspective, part, configuration.side);
        
        var playerObj = ub.data.currentApplication;
        PerspectiveController.prototype.setPerspective(_perspective);
        
        if (ub.funcs.isCurrentSport("Baseball") && ub.funcs.is_upper()) {
            PlayerNamePanel.funcs.repositionPlayerName(playerObj.code);
        }

        PlayerNamePanel.funcs.initializePlayerName(playerObj.code);
    },

    onChangeAccentColor: function() {
        var dataId = $(this).attr('data-id');
        var _settingsObject = ub.funcs.getApplicationSettings(dataId);
        var _layer_no = $(this).data('layer-no');
        var _color_code = $(this).data('color-code');
        var _layer_name = $(this).data('layer-name');
        var _colorObj = ub.funcs.getColorByColorCode(_color_code);
        var _layer = _.find(_settingsObject.accent_obj.layers, {name: _layer_name});

        if (TextShapeCore.utilities.isTextShape(_settingsObject.code)) {
            if (_settingsObject.text_shape_type === "arc") {
                TextShapeCore.customControllers.changeArcColor(_settingsObject, _layer_name, _layer_no, _colorObj);
            } else {
                TextShapeCore.canvas.changeColor(_settingsObject, _layer_name, _layer_no, _colorObj);
            }
        } else {
            ApplicationCore.controllers.changeTextApplicationColor(_settingsObject, _layer_name, _layer_no, _colorObj);
        }

        // Changing active color
        $(this).parent().parent().find('button').removeClass('activeColorItem').html('');
        $(this).addClass('activeColorItem').html('<span class="fa fa-check fa-1x cp-margin-remove cp-padding-remove cp-check-color-font-size"></span>');
    },

    onSelectFontAccent: function() {
        if ($(this).hasClass("uk-active")) {
            return;
        }

        var code = $(this).closest(".playerOptionContainer").data("code");
        var settingsObj = ub.funcs.getApplicationSettings(code);
        var accentID = $(this).data('accent-id');

        if (TextShapeCore.utilities.isTextShape(settingsObj.code)) {
            if (settingsObj.text_shape_type === "arc") {
                TextShapeCore.customControllers.renderTextShapeAccent(settingsObj, accentID)
            } else {
                TextShapeCore.canvas.changeAccent(accentID, settingsObj);
            }
        } else {
            // Change application accent
            ApplicationCore.controllers.changeTextApplicationAccent(accentID, settingsObj);
        }

        PlayerNamePanel.funcs.initializePlayerName(code);

        _.delay(function() {
            $("#primary_options_container").scrollTo($(".playerOptionContainer .con-select.con-palettes"), {duration: 300});
        }, 100)
    },

    onChangeFontStyle: function() {
        var direction = $(this).data("direction");
        var code = $(this).closest(".playerOptionContainer").data("code");
        var app = ub.funcs.getApplicationSettings(code);
        
        if (TextShapeCore.utilities.isTextShape(code)) {
            if (app.text_shape_type === "arc") {
                TextShapeCore.customControllers.changeTextArcFontStyle(code, direction);
            } else {
                TextShapeCore.canvas.changeFont(app.code, direction);
            }
        } else {
            ApplicationCore.controllers.changeTextApplicationFontStyle(code, direction);
        }
    },

    onRemovePlayerName: function() {
        var code = $(this).data("code");
        var _application = ub.funcs.getApplicationSettings(code);
        UIkit.modal.confirm('Are you sure you want to delete Player Name #' + _application.code + '?').then(function() {
            ub.funcs.deleteLocation(_application.code);
            PlayerNamePanel.funcs.loadAddPlayer();
        }, function () {
        });
    },

    onCreateFontPopUp: function() {
        var app_code = $(this).data('application-code');
        var settingsObj = ub.funcs.getApplicationSettings(app_code);

        if (typeof settingsObj !== "undefined") {
            var sample_text = $(".modifier_main_container #player-name-panel input.app-letters-input").val();

            if (_.isEmpty(sample_text)) {
                sample_text = "Sample Text";
            }

            ApplicationCore.utilities.openFontModal(sample_text, settingsObj);
        } else {
            ub.utilities.info("Error: Application code " + app_code + " is invalid code.");
        }
    },

    onKeyPressApplicationText: function(e) {
        var ENTER = 13;
        var _val = $(this).val();
        var id = $(this).closest('#player-name-panel').data('code').toString();
        var _settingsObject = ub.funcs.getApplicationSettings(id);

        if (_val.length >= 13) {
            $(this).addClass("uk-form-warning");
            $("#player-name-panel .team-name-helper-message").removeClass("uk-hidden");
        } else if (_val.length === 0) {
            $(this).addClass("uk-form-warning");
            TeamNamePanel.funcs.addInputTextMessage("This text field is required.");
            return;
        } else {
            $(this).removeClass("uk-form-warning");
            $(".team-name-helper-message").addClass("uk-hidden");
        }
        
        if (e.keyCode === ENTER) {
            if (TextShapeCore.utilities.isTextShape(id)) {
                if (_settingsObject.text_shape_type === "arc") {
                    TextShapeCore.controllers.changeTextShapeText(_val, id);
                } else {
                    TextShapeCore.canvas.changeText(_settingsObject, _val)
                }
            } else {
                PlayerNamePanel.funcs.onChangePlayerNameText(_val, _settingsObject);
            }

            $(this).blur();
            $(this).removeClass("uk-form-warning");
            $(".team-name-helper-message").addClass("uk-hidden");
        }

        if (e.charCode == 8 || e.charCode == 0) {
            return null
        } else {
            return e.charCode >= 65 && e.charCode <= 90 || e.charCode >= 97 && e.charCode <= 122 || e.charCode === 32 || e.charCode === 45 
                || e.charCode >= 48 && e.charCode <= 57 // Allow Numbers (as per Sir.Kory)
        }
    },

    onBlurApplicationText: function() {
        var _val = $(this).val();
        var id = $(this).closest('#player-name-panel').data('code').toString();
        var _settingsObject = ub.funcs.getApplicationSettings(id);

        if (_val.length === 0) {
            $("#player-name-panel .app-letters-input").val(_settingsObject.text);
            $(this).removeClass("uk-form-warning");
            $("#player-name-panel .team-name-helper-message").addClass("uk-hidden");
            return;
        }
        
        if (TextShapeCore.utilities.isTextShape(id)) {
            if (_settingsObject.text_shape_type === "arc") {
                TextShapeCore.controllers.changeTextShapeText(_val, id);
            } else {
                TextShapeCore.canvas.changeText(_settingsObject, _val)
            }
        } else {
            PlayerNamePanel.funcs.onChangePlayerNameText(_val, _settingsObject);
        }
    },

    onSelectTextLayout: function() {
        var current_layout = $(this).find(".player-name-layout").data("player-name-layout");
        var code = $(this).closest('#player-name-panel').data('code');
        var application = ub.funcs.getApplicationSettings(code);
        var type = PlayerNamePanel.type;
        // Open Text shape layout modal
        TextShapeCore.utilities.openTextLayoutModal(code, type.replace("_", " "), current_layout, PlayerNamePanel.type);
    },

    onChangeTextLayout: function() {
        var direction = $(this).data("direction");
        var id = $(this).closest('#player-name-panel').data('code').toString();
        var layout_container_el = $('#player-name-layout-container');
        var player_name_layout_el = $('.select-player-name-layout .player-name-layout', layout_container_el);
        var current_team_layout = player_name_layout_el.data("player-name-layout");
        var application = ub.funcs.getApplicationSettings(id);

        var textShapes = PlayerNamePanel.availableTextShapes;
        var current_type_key = textShapes.indexOf(current_team_layout);

        switch(direction) {
            case TextShapeCore.TEXT_SHAPE_LAYOUT_NEXT_TEXT:
                current_type_key++;
                break;

            case TextShapeCore.TEXT_SHAPE_LAYOUT_PREVIOUS_TEXT:
                current_type_key--;
                break;
        }

        if (current_type_key < 0) {
            current_type_key = 0;
        } else if (current_type_key > (textShapes.length - 1)) {
            current_type_key = textShapes - 1;
        } else {
            var new_layout = textShapes[current_type_key];
            PlayerNamePanel.funcs.changePlayerLayout(new_layout, application);
        }
    }
}

PlayerNamePanel.funcs = {
    loadAddPlayer: function() {
        var template = document.getElementById("m-player-name-container").innerHTML;
        var renderTemplate = Mustache.render(template);
        $('.modifier_main_container').html("");
        $('.modifier_main_container').html(renderTemplate);
    },

    initializePlayerName: function(code) {
        var that = this;
        var playerObj = ub.funcs.getApplicationSettings(code);
        // Set Text Shape model
        TextShapeCore.utilities.setTextShapeModel(TextShapeCore.PLAYER_NAME_TYPE);

        var objStock = {
            application_type: playerObj.application_type,
            type: playerObj.application.name.toUpperCase(),
            defaultText: playerObj.text,
            code: playerObj.code,
            perspective: playerObj.application.views[0].perspective,
            hasAccents: true,
            accents: that.accent(playerObj),
            hasFontStyle: true,
            fontStyle: that.fontStyle(playerObj),
            hasTeamLayout: true,
            teamLayout: that.teamLayout(playerObj),
            hasColors: true,
            colorContainer: that.colorSelection(playerObj, "Player Name Colors"),
            hasFontSize: true,
            fontSizeSlider: that.fontSizeSlider(playerObj)
        };

        var _htmlBuilder = ub.utilities.buildTemplateString('#m-player-name-modifier-control', objStock);
        $(".modifier_main_container").html("");
        $(".modifier_main_container").html(_htmlBuilder);
        ub.funcs.activateMoveTool(playerObj.code);
        ub.funcs.initializer();
        var primaryView = ub.funcs.getPrimaryView(playerObj.application);
        PerspectiveController.prototype.setPerspective(primaryView);

        // Disable Functionality
        RichardsonOrderEditor.statusChecker(PlayerNamePanel.funcs.disablePlayerNumberModifier, 500);
    },

    accent: function(settingsObject) {
        var _accents = []
        _.map(ub.data.accents.items, function (j) {
            var acc = {
                'thumbnail': '/images/sidebar/' + j.thumbnail,
                'id': j.id,
                'code': j.code,
                'title': j.code.replace(/_/g, " "),
                'active': settingsObject.accent_obj.id === j.id ? 'uk-active' : '',
            };

            _accents.push(acc);
        });

        var templateData = {
            accents: _accents
        };

        var _htmlBuilder = ub.utilities.buildTemplateString('#m-player-name-accent', templateData);

        return _htmlBuilder;
    },

    fontStyle: function(settingsObject) {
        var templateData = {
            fontStyle: settingsObject.font_obj.name,
            fontCaption: settingsObject.font_obj.caption,
            code: settingsObject.code
        };

        var _htmlBuilder = ub.utilities.buildTemplateString('#m-player-name-font', templateData);
        return _htmlBuilder;
    },

    teamLayout: function(settingsObject) {
        var textShapeObject = TextShapeCore.utilities.getTextShape(settingsObject.code);
        var text_shape_type = "none";

        if (textShapeObject) {
            text_shape_type = textShapeObject.text_shape_type;
        }

        var _htmlBuilder = ub.utilities.buildTemplateString('#m-player-name-layout', {
            playername_layout: text_shape_type,
            playername_layout_text: ub.utilities.titleCase(text_shape_type),
        });

        return _htmlBuilder;
    },

    colorSelection: function(_settingsObject, title) {
        var _colorBlock = '';
        var _html = '';

        _html += '<div class="colorSelectionContainer">';
        _html  += '<h6 class="uk-text-small uk-text-uppercase uk-text-bold uk-margin-top uk-margin-small-bottom abrade-black">'+title+'</h6>';
        _html += '<div class="uk-grid-small grid-tiny active-bgc-red" uk-switcher uk-grid>';

        _.each(_settingsObject.accent_obj.layers, function (layer, index) {
            var _hexCode = layer.default_color;
            var _color = ub.funcs.getColorObjByHexCode(_hexCode);
            var _layerNo = layer.layer_no - 1;

            if (layer.name === 'Mask' || layer.name === 'Pseudo Shadow') {
                return;
            }

            _color = _settingsObject.color_array[_layerNo];

            // Use default color if team color is short
            if (typeof _color === "undefined") {
                _hexCode = layer.default_color;
                _color = ub.funcs.getColorObjByHexCode(_hexCode);
                ub.utilities.error('Undefined color found here!!!');
            }

            if (typeof _color !== 'undefined') {
                if (index === 0) {
                    _html += '<div><button class="uk-width-1-1 padding-tiny-vertical uk-button-default uk-text-capitalize uk-button-small">' + layer.name + '</button></div>';
                } else {
                    _html += '<div class="uk-padding-remove"><button class="uk-width-1-1 padding-tiny-vertical uk-button-default uk-text-capitalize uk-button-small">' + layer.name + '</button></div>';
                }

                // building separated color blocks
                _colorBlock += PlayerNamePanel.funcs.createColorBlock(_settingsObject.code, _color.color_code, layer.layer_no, layer.name, layer.default_color, 'accent');
            } else {
                util.error('Hex Code: ' + _hexCode + ' not found!');
            }
        });

        _html += '</div>';
        _html += '<ul class="uk-switcher uk-margin-small-top color-list-container">';
        _html += _colorBlock;
        _html += '</ul>';
        _html += '</div>';

        return _html;
    },

    createColorBlock: function(_id, activeColorCode, layer_no, layer_name, active_color, objectType) {
        var _html = '';
        var _teamColors = ub.data.secondaryColorPalette;
        var _objectType = objectType;

        if (typeof objectType === "undefined") {
            _objectType = 'not-set';
        }

        _teamColors = _.sortBy(_teamColors, "order");
        // _html += '<div id="tab-' + _id + '-' + layer_no + '" class="tab-pane fade cp-margin-remove" style="padding-bottom: 50px; padding-top: 20px;">';
        _html += '<li>'
        _html += '<div class="con-select con-palettes">'
        _html += '<div class="uk-grid-small grid-tiny uk-grid-match uk-child-width-auto uk-text-center m-palette-color" uk-grid>'
        _.each(_teamColors, function (_color) {
            var _checkMark = '';
            var _class = '';
            var _colorObj = ub.funcs.getColorByColorCode(_color.color_code);

            if (activeColorCode === _color.color_code) {
                _checkMark = '<span class="fa fa-check fa-1x cp-margin-remove cp-padding-remove cp-check-color-font-size" style="color:#' + _colorObj.forecolor + ';"></span>';
                _class = 'activeColorItem';
            }

            _html += '<div>';
            if (_colorObj.color_code === "W") {
                _html += '<button uk-tooltip="title:' + _colorObj.alias + '; pos: left;" class="uk-inline box-palette btn-selection-choice palette-color palette colorItem '+ _class +'" style="background-color:#ffff; color:#' + _colorObj.forecolor + ';" data-id="' + _id + '" data-layer-name="' + layer_name + '" data-color-code="' + _color.color_code + '" data-layer-no="' + layer_no + '" data-object-type="' + _objectType + '">';
            } else {
                _html += '<button uk-tooltip="title:' + _colorObj.alias + '; pos: left;" class="uk-inline box-palette btn-selection-choice palette-color palette colorItem '+ _class +'" style="background-color:#' + _colorObj.hex_code + '; color:#' + _colorObj.forecolor + ';" data-id="' + _id + '" data-layer-name="' + layer_name + '" data-color-code="' + _color.color_code + '" data-layer-no="' + layer_no + '" data-object-type="' + _objectType + '">';
            }
            _html += _checkMark;
            _html += '</button>';
            _html += '</div>';
        });

        _html += '</div>';
        _html += '</div>';
        _html += '</li>';

        return _html;
    },

    fontSizeSlider: function(_settingsObject) {
        var _htmlBuilder = ub.utilities.buildTemplateString('#m-player-name-font-size-slider', {code: _settingsObject.code});
        return _htmlBuilder;
    },

    repositionPlayerName: function(code) {
        var playerNameobject = ub.funcs.getApplicationSettings(code);

        if (typeof playerNameobject !== "undefined") {
            var perspective = playerNameobject.application.views[0].perspective;
            var playerNameSprite = ub.objects[perspective + '_view']['objects_' + playerNameobject.code];

            playerNameSprite.position.y = 165;

            var application = playerNameobject.application.views[0].application;
            application.center = playerNameSprite.position;

            var _locationMarker = ub.objects[perspective + '_view']['locations_' + playerNameobject.code];
            _locationMarker.position = playerNameSprite.position;

            ub.funcs.updateCoordinates(playerNameobject);
            ub.updateApplicationSpecsPanel(playerNameobject.code);
        }
    },

    changePlayerLayout: function(layout, application) {
        var layout_container_el = $('#player-name-layout-container');
        var player_name_layout_el = $('.select-player-name-layout .player-name-layout', layout_container_el);

        player_name_layout_el.data('player-name-layout', layout);
        player_name_layout_el.text(ub.utilities.titleCase(layout));

        if (layout === "arc") {
            TextShapeCore.customControllers.renderARC(application, "player_name", layout);
        } else {
            if (application.application_type !== TextShapeCore.TEXT_SHAPE_TYPE) {
                TextShapeCore.canvas.addTextShapeConfiguration(application, "player_name", layout);
            } else {
                TextShapeCore.canvas.changeTextShape(application, layout);
            }
        }

        PlayerNamePanel.funcs.initializePlayerName(application.code);
    },

    onChangePlayerNameText: function(text, _settingsObject) {
        _settingsObject.text = text;

        if (text.length !== 0) {
            ApplicationCore.controllers.changeApplicationText(text, _settingsObject)
            return;
        } else {
            ApplicationCore.controllers.changeApplicationText(" ", _settingsObject)
            return;
        }
    },

    disablePlayerNumberModifier: function() {
        var parent = $("div#player-name-panel");
        var disableClass = "uk-disabled";

        // Disable Remove
        $(".remove-player-name", parent).addClass(disableClass);
        // Font Selector
        $("#font-styles-container", parent).addClass(disableClass);
        // Layout Selector
        $("#player-name-layout-container", parent).addClass(disableClass);
        // Disable Slider
        $(".font-slider-container", parent).addClass(disableClass);
        // Disable Accent Selector
        $(".m-accents", parent).addClass(disableClass);
        // Disable Color Selector
        $(".colorSelectionContainer .color-list-container", parent).addClass(disableClass);
        // Add Team Name disable
        $(".add-player-name", parent).addClass(disableClass);
    }
}
